import { Injectable } from '@angular/core';
import domtoimage from 'dom-to-image';
import * as base64js from 'base64-js';
import { Transfer, TransferObject } from '@ionic-native/transfer';

declare var cordova;

@Injectable()
export class NodeToImgService {

    constructor(
        private transfer: Transfer
    ) { }

    getBase64Image(node: any) {
        return new Promise<any>((resolve, reject) => {
            domtoimage.toPng(node)
                .then(dataUrl => {
                    resolve(dataUrl);
                });
        });
    }

    downloadFile(imageLink) {
        return new Promise<any>((resolve, reject) => {
            let that = this;

            const fileTransfer: TransferObject = this.transfer.create();

            let storageDirectory = "";

            const imageLocation = imageLink;

            // if (this.platform.is('ios')) {
            storageDirectory = cordova.file.documentsDirectory;
            // }
            // else if (this.platform.is('android')) {
            //     storageDirectory = cordova.file.dataDirectory;
            // }

            let image = "image" + new Date().getTime() + ".png";

            console.log('storageDirectory: ', storageDirectory);
            console.log('image: ' + image);
            console.log('storageDirectory + image: ' + storageDirectory + image)
            fileTransfer.download(imageLocation, storageDirectory + image).then((entry) => {
                console.log('inside-entry: ', entry.toURL());
                resolve(entry.toURL());
            }, (error) => {
                console.log(error.source);
            });
        });
    }

    base64ToFile(base64: string): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            const bytes = base64js.toByteArray(base64);
            const file = new Blob([bytes], { type: 'image/png' });
            resolve(file);
        });
    }
}


// WEBPACK FOOTER //
// /src/providers/nodetoimg.service.ts